import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import Reactions from '@/components/Reactions';
import { TReaction } from '@/types/api';
import { dateToMonthDayFormat } from '@/utils/format';

interface CommentComponentProps {
  date: string | Date;
  comment: string;
  commentId?: string;
  feedbackId?: string;
  userName?: string;
  reactions?: TReaction[];
  refetchCheckin: () => void;
}

const CommentComponent = function ({
  userName = 'Comment',
  commentId,
  feedbackId,
  date,
  comment,
  refetchCheckin,
  reactions,
}: CommentComponentProps): JSX.Element {
  const dateToShow = useMemo(() => dateToMonthDayFormat(date), [date]);

  return (
    <Box marginBottom={3} data-testid="comment-component">
      <Box display="flex" alignItems="flex-end">
        <Typography fontWeight={600} color="primary" marginRight={1} data-testid="comment-username">
          {userName}
        </Typography>
        <Typography fontWeight={300} color="primary" fontSize={14} data-testid="comment-date">
          {dateToShow}
        </Typography>
      </Box>

      <Typography
        whiteSpace="pre-line"
        marginTop={1}
        color={blueGrey[800]}
        data-testid="comment-text"
      >
        {comment}
      </Typography>
      <Reactions
        refetchCheckin={refetchCheckin}
        reactions={reactions}
        commentId={commentId}
        feedbackId={feedbackId}
      />
    </Box>
  );
};

export default CommentComponent;
